import React from 'react';

export default function HomeCommand() {
  return (
    <section className="command" aria-labelledby="command-title">
      <div className="command-copy">
        <p className="eyebrow">Business compliance operating system</p>
        <h2 id="command-title" className="dh-title-2">
          A stronger way to manage risk, records, people, and decisions.
        </h2>
        <p className="dh-text">
          DALMAF can be positioned as the single control room for companies that need legal
          documentation, audit discipline, statutory compliance, and people governance to move
          together instead of separately.
        </p>
      </div>
      <div className="command-grid" aria-label="DALMAF delivery model">
        <div>
          <span className="cmd-num">01</span>
          <strong className="cmd-title">Diagnose</strong>
          <p className="dh-text">Review legal, audit, tax, and HR readiness.</p>
        </div>
        <div>
          <span className="cmd-num">02</span>
          <strong className="cmd-title">Structure</strong>
          <p className="dh-text">Build documentation, filings, controls, and workflows.</p>
        </div>
        <div>
          <span className="cmd-num">03</span>
          <strong className="cmd-title">Protect</strong>
          <p className="dh-text">Reduce operational exposure with continuous advisory.</p>
        </div>
        <div>
          <span className="cmd-num">04</span>
          <strong className="cmd-title">Scale</strong>
          <p className="dh-text">Prepare companies and investors for disciplined growth.</p>
        </div>
      </div>
    </section>
  );
}
